import { useState } from 'react';
import { InformationIcon } from 'assets/images/countryList';
import './countriesHeader.scss';

/**
 * Encabezado de la tabla de países.
 */
const CountriesHeader = () => {
  const [showInformation, setShowInformation] = useState<boolean>(false);

  const renderInformationTooltip = () => {
    return (
      <span className="information">
        <span className="informationText">
          <strong>Y:</strong> Alfanumérico
        </span>
        <span className="informationText">
          <strong>X: </strong>Letra
        </span>
        <span className="informationText">
          <strong>0:</strong> Número
        </span>
      </span>
    );
  };

  return (
    <thead>
      <tr>
        <th className="countryFlagColumn">País</th>
        <th className="countryCurrencyColumn">Monedas</th>
        <th className="exchangeRateColumn">Tasa de cambio</th>
        <th className="taxesColumn">Impuestos</th>
        <th className="phoneCodeColumn">Indicativo</th>
        <th className="documentColumn">
          <span
            className="documentColumnLabel"
            onMouseEnter={() => setShowInformation(true)}
            onMouseLeave={() => setShowInformation(false)}
          >
            Tipo de documento fiscal
            <span className="floatInformation">
              <InformationIcon />
            </span>
            {showInformation && renderInformationTooltip()}
          </span>
        </th>
        <th className="providerColumn">Proveedores</th>
        <th className="registryColumn">Registro</th>
        <th className="buyColumn">Venta</th>
        <th className="servicesColumn">Servicios</th>
        <th className="storageColumn">Bodegas</th>
        <th className="costsCurrencyColumn">Moneda (solo costo)</th>
        <th className="actionsColumn" />
      </tr>
    </thead>
  );
};

export default CountriesHeader;
